import styled from "styled-components";

export const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  font-family: "Inter";
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  background-color: #fff;
  padding: 16px;
  box-sizing: border-box;
  border-radius: 8px;
`;

export const MenuButtons = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
`;
